
import React from "react";
import AudioPlayer from "../audio/AudioPlayer";
import { Card, CardContent } from "@/components/ui/card";
import { Play, Hotel } from "lucide-react";
import { Button } from "@/components/ui/button";

interface UseCaseDetailRow {
  label: string;
  value: string;
}

interface HospitalityUseCaseProps {
  title: string;
  description: string;
  details: UseCaseDetailRow[];
  audioSrc?: string;
}

const HospitalityUseCase: React.FC<HospitalityUseCaseProps> = ({
  title,
  description,
  details,
  audioSrc
}) => {
  return (
    <Card className="w-full max-w-md mx-auto bg-[#1A1F2C] text-white border-none rounded-3xl overflow-hidden shadow-xl">
      <CardContent className="p-8">
        <div className="mb-8">
          <span className="block text-gray-400 uppercase text-center tracking-wider mb-6 text-sm font-medium">USE CASE</span>
          <h2 className="text-3xl font-bold text-center mb-4 flex items-center justify-center gap-3">
            {title} 
            <span className="inline-block">🏨</span>
          </h2>
          <p className="text-center text-gray-300 mb-6">
            {description}
          </p>
        </div>

        <div className="space-y-6 mb-8">
          {details.map((detail, index) => (
            <div key={index} className="flex border-b border-gray-700/50 pb-3">
              <span className="font-medium w-1/3 text-right mr-6 text-gray-400">{detail.label}</span>
              <span className="text-white w-2/3">{detail.value}</span>
            </div>
          ))}
        </div>

        <AudioPlayer title="Listen to Demo Call" audioSrc={audioSrc} />
      </CardContent>
    </Card>
  );
};

export default HospitalityUseCase;
